import { useLanguage } from "../i18n/LanguageContext";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import CrochetLady from "../components/CrochetLady";

export default function NotFound() {
  const { t } = useLanguage();

  useEffect(() => {
    // Set page keywords
    document.querySelector('meta[name="keywords"]').setAttribute(
      "content",
      `full-stack developer, software developer, software engineer, computer engineer, software developer in Kuwait,Kuwait, 
            Coded Academy, AUM, Ruby on Rails, Ruby, React, JavaScript, TypeScript, Nextjs, HTML, CSS, website, application, 
            Not Found Page, 404`,
    );
  }, []);

  return (
    <div className="not-found">
      <h1 className="visually-hidden">404</h1>
      <CrochetLady />
      <h2>{t("notFound.heading")}</h2>
      <Link to="/" className="crochet-home">
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}
